'use client';

import { useEffect } from 'react';

import applyGoogleTranslateDOMPatch from '@utils/applyGoogleTranslateDOMPatch';

/**
 * Custom hook that applies the Google Translate DOM patch to prevent crashes in Next.js applications
 *
 * This hook safely applies the DOM patching only once when the component mounts, making it
 * easier to integrate the Google Translate fix in your application without side effects.
 *
 * @remarks
 * This should be used in a client component, preferably at the top level of your application
 * such as in a ClientWrapper component within your RootLayout.
 *
 * @see {@link https://github.com/vercel/next.js/issues/58055#issuecomment-3133346877 Next.js issue #58055}
 * @author kasimsen-setur
 * @since 2025-07-31
 *
 * @returns {void}
 */
const useApplyGoogleTranslateDOMPatch = () => {
  useEffect(() => {
    applyGoogleTranslateDOMPatch();
  }, []);
};

export default useApplyGoogleTranslateDOMPatch;
